import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MojoSelectModule } from 'mojo-select';
import { MojoValidationModule } from 'mojo-validation';

import { MaterialModule } from '@material/material.module';

import { SocialInfoComponent } from './social-info.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    MojoValidationModule,
    MojoSelectModule,
  ],
  declarations: [SocialInfoComponent],
  exports: [SocialInfoComponent],
  providers: [{ provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }],
})
export class SocialInfoModule {}
